import React from 'react';
import WelcomeVideoPlayer from './WelcomeVideoPlayer';
import styles from './welcomeVideo.module.css';

interface WelcomeVideoContainerProps {
  embedUrl: string;
  title: string;
}

const WelcomeVideoContainer: React.FC<WelcomeVideoContainerProps> = ({ embedUrl, title }) => (
  <div className={styles.container}>
    <WelcomeVideoPlayer embedUrl={embedUrl} title={title} />
  </div>
);

export default WelcomeVideoContainer;
